module.exports = __webpack_public_path__ + "img/testExperienceImage.2ea9b84d.jpg";